import { useEffect } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { userService } from '@services/userService'
import { useAuthStore } from '@store/useAuthStore'

/** Bloqueia rotas da app quando o trial expirou ou não há acesso. */
export function ApplicationAccessGate() {
  const { hasApplicationAccess, user, setApplicationAccess } = useAuthStore()

  useEffect(() => {
    if (!user?.id || hasApplicationAccess !== null) {
      return
    }
    userService
      .getEntryLevelStatus()
      .then((status) => {
        setApplicationAccess(status.applicationAccess ?? !status.expired)
      })
      .catch(() => {
        setApplicationAccess(true)
      })
  }, [user?.id, hasApplicationAccess, setApplicationAccess])

  if (hasApplicationAccess === false) {
    return <Navigate to="/subscription-required" replace />
  }

  return <Outlet />
}
